import { actionCreator } from 'utils';
import * as templateTypes from '../types/templateTypes';

// L O A D   T E M P L A T E
export function loadTemplate() {
    return {
        type: templateTypes.LOAD_TEMPLATE,
    };
}

export function loadTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_TEMPLATE, 'res'),
        data,
    };
}

export function loadTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_TEMPLATE, 'err'),
    };
}
// L O A D   T E M P L A T E

// S E T   T E M P L A T E   F I L T E R
export function setTemplatePagination(key, pagination) {
    return {
        type: templateTypes.SET_TEMPLATE_PAGINATION,
        key,
        pagination,
    };
}

export function setTemplateFilter(key, value) {
    return {
        type: templateTypes.SET_TEMPLATE_FILTER,
        key,
        value,
    };
}

export function resetTemplateFilters() {
    return {
        type: templateTypes.RESET_TEMPLATE_FILTERS,
    };
}
// S E T   T E M P L A T E   F I L T E R

// T O G G L E   C O N F I G U R A T I O N   S T A T U S
export function toggleTemplateStatus(id, status) {
    return {
        type: templateTypes.TOGGLE_TEMPLATE_STATUS,
        id,
        status,
    };
}

export function toggleTemplateStatusRes() {
    return {
        type: actionCreator(templateTypes.TOGGLE_TEMPLATE_STATUS, 'res'),
    };
}

export function toggleTemplateStatusErr() {
    return {
        type: actionCreator(templateTypes.TOGGLE_TEMPLATE_STATUS, 'err'),
    };
}
// T O G G L E   C O N F I G U R A T I O N   S T A T U S

// S E T   C H E C K E D   T E M P L A T E
export function setCheckedTemmplates(ids) {
    return {
        type: templateTypes.SET_CHECKED_TEMPLATES,
        ids,
    };
}
// S E T   C H E C K E D   T E M P L A T E

// C H E C K E D   T E M P L A T E
export function CheckedTemplates(ids, temp) {
    return {
        type: templateTypes.CHECKED_TEMPLATES,
        ids,
        temp,
    };
}

export function CheckedTemplatesRes() {
    return {
        type: actionCreator(templateTypes.CHECKED_TEMPLATES, 'res'),
        ids: [],
    };
}

export function CheckedTemplatesErr() {
    return {
        type: actionCreator(templateTypes.CHECKED_TEMPLATES, 'err'),
    };
}
// C H E C K E D   T E M P L A T E

// A D D   N E W   T E M P L A T E
export function addTemplate(data) {
    return {
        type: templateTypes.ADD_TEMPLATE,
        data,
    };
}

export function addTemplateRes(loading, success) {
    return {
        type: actionCreator(templateTypes.ADD_TEMPLATE, 'res'),
        loading,
        success,
    };
}

export function addTemplateErr(error) {
    return {
        type: actionCreator(templateTypes.ADD_TEMPLATE, 'err'),
        error,
    };
}
// A D D   N E W   T E M P L A T E

// L O A D   E D I T A B L E   T E M P L A T E
export function loadEdiTableTemplate(id) {
    return {
        type: templateTypes.LOAD_EDITTABLE_TEMPLATE,
        id,
    };
}

export function loadEdiTableTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_EDITTABLE_TEMPLATE, 'res'),
        data,
    };
}

export function loadEdiTableTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_EDITTABLE_TEMPLATE, 'err'),
    };
}

export function setEmptyEdiTableTemplate() {
    return {
        type: templateTypes.SET_EMPTY_EDITTABLE_TEMPLATE,
    };
}
// L O A D   E D I T A B L E   T E M P L A T E

// L O A D   E D I T A B L E   P A C K A G E S   F R O M   T E M P L A T E
export function loadEdiTablePackagesFromTemplate(ids) {
    return {
        type: templateTypes.LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE,
        ids,
    };
}

export function loadEdiTablePackagesFromTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE, 'res'),
        data,
    };
}

export function loadEdiTablePackagesFromTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_EDITTABLE_PACKAGES_FROM_TEMPLATE, 'err'),
    };
}
// L O A D   E D I T A B L E   P A C K A G E S   F R O M   T E M P L A T E

// E D I T   T E M P L A T E
export function editTemplate(data) {
    return {
        type: templateTypes.EDIT_TEMPLATE,
        data,
    };
}

export function editTemplateRes(loading, success) {
    return {
        type: actionCreator(templateTypes.EDIT_TEMPLATE, 'res'),
        loading,
        success,
    };
}

export function editTemplateErr() {
    return {
        type: actionCreator(templateTypes.EDIT_TEMPLATE, 'err'),
    };
}
// E D I T   T E M P L A T E

// C L O N E   P A C K A G E S   T O   T E M P L A T E
export function clonePackagesToTemplate(data) {
    return {
        type: templateTypes.CLONE_PACKAGES_TO_TEMPLATE,
        data,
    };
}

export function clonePackagesToTemplateRes() {
    return {
        type: actionCreator(templateTypes.CLONE_PACKAGES_TO_TEMPLATE, 'res'),
    };
}

export function clonePackagesToTemplateErr(error) {
    return {
        type: actionCreator(templateTypes.CLONE_PACKAGES_TO_TEMPLATE, 'err'),
        error,
    };
}
// C L O N E   P A C K A G E S   T O   T E M P L A T E

// A D D   B U L K   P A C K A G E S
export function updatePackageToList(payload, id) {
    return {
        type: templateTypes.UPDATE_PACKAGES_TO_LIST,
        payload,
        id,
    };
}

export function addBulkPackagesForTemplate(data) {
    return {
        type: templateTypes.ADD_BULK_PACKAGES_FOR_TEMPLATE,
        data,
    };
}

export function addBulkPackagesForTemplateRes() {
    return {
        type: actionCreator(templateTypes.ADD_BULK_PACKAGES_FOR_TEMPLATE, 'res'),
    };
}

export function addBulkPackagesForTemplateErr(error) {
    return {
        type: actionCreator(templateTypes.ADD_BULK_PACKAGES_FOR_TEMPLATE, 'err'),
        error,
    };
}
// A D D   B U L K   P A C K A G E S

// D E L E T E    B U L K   P A C K A G E S
export function deleteBulkPackagesForTemplate(data) {
    return {
        type: templateTypes.DELETE_BULK_PACKAGES_FOR_TEMPLATE,
        data,
    };
}

export function deleteBulkPackagesForTemplateRes() {
    return {
        type: actionCreator(templateTypes.DELETE_BULK_PACKAGES_FOR_TEMPLATE, 'res'),
    };
}

export function deleteBulkPackagesForTemplateErr(error) {
    return {
        type: actionCreator(templateTypes.DELETE_BULK_PACKAGES_FOR_TEMPLATE, 'err'),
        error,
    };
}
// D E L E T E    B U L K   P A C K A G E S

// R E S E T   P A C K A G E   F R O M    T E M P L A T E
export function resetPackageFromTemplate(prop) {
    return {
        type: templateTypes.RESET_PACKAGE_FROM_TEMPLATE,
        prop,
    };
}

export function resetPackagePaginationFromTemplate() {
    return {
        type: templateTypes.RESET_PACKAGE_PAGINATION_FROM_TEMPLATE,
    };
}
// R E S E T   P A C K A G E   F R O M    T E M P L A T E

// L O A D   P A C K A G E S   F O R   T E M P L A T E
export function loadPackagesForTemplate() {
    return {
        type: templateTypes.LOAD_PACKAGES_FOR_TEMPLATE,
    };
}

export function loadPackagesForTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_PACKAGES_FOR_TEMPLATE, 'res'),
        data,
    };
}

export function loadPackagesForTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_PACKAGES_FOR_TEMPLATE, 'err'),
    };
}
// L O A D   P A C K A G E S   F O R   T E M P L A T E


// S E T   C H E C K E D   P A C K A G E S   F O R   T E M P L A T E
export function setCheckedPackagesForTemplate(prop, ids) {
    return {
        type: templateTypes.SET_CHECKED_PACKAGES_FOR_TEMPLATE,
        prop,
        ids,
    };
}
// S E T   C H E C K E D   P A C K A G E S   F O R   T E M P L A T E

// S E T   P A C K A G E S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   T E M P L A T E
export function setFiltersPackageForConfiguration(key, value) {
    return {
        type: templateTypes.SET_FILTER_PACKAGE_FOR_CONFIGURATION,
        key,
        value,
    };
}

export function setFiltersPackageForConfigurationRes(data) {
    return {
        type: actionCreator(templateTypes.SET_FILTER_PACKAGE_FOR_CONFIGURATION, 'res'),
        data,
    };
}

export function setPackagePaginationForTemplate(key, pagination) {
    return {
        type: templateTypes.SET_PACKAGE_PAGINATION_FOR_TEMPLATE,
        key,
        pagination,
    };
}

export function setPackagePaginationChoosen(key, pagination) {
    return {
        type: templateTypes.SET_PACKAGE_PAGINATION_CHOOSEN,
        key,
        pagination,
    };
}

export function setPackageSortForTemplate(prop, sort) {
    return {
        type: templateTypes.SET_PACKAGE_SORT_FOR_TEMPLATE,
        prop,
        sort,
    };
}

export function resetPackageFiltersForTemplate(prop) {
    return {
        type: templateTypes.RESET_PACKAGE_FILTERS_FOR_TEMPLATE,
        prop,
    };
}

export function resetPackagePaginationList() {
    return {
        type: templateTypes.RESET_PACKAGE_PAGINATION_LIST,
    };
}
// S E T   P A C K A G E S   F I L T E R   &   P A G I N A T I O N   &   S O R T   &   R E S E T   F O R   T E M P L A T E

// U P D A T E   T R A N S L A T E   D E S I G N   T E M P L A T E
export function updateTranslateDesignTemplate(key) {
    return {
        type: templateTypes.UPDATE_TRANSLATE_DESIGN_TEMPLATES,
        key,
    };
}

export function updateTranslateDesignTemplateRes(key, loading, success) {
    return {
        type: actionCreator(templateTypes.UPDATE_TRANSLATE_DESIGN_TEMPLATES, 'res'),
        key,
        loading,
        success,
    };
}

export function updateTranslateDesignTemplateErr(key) {
    return {
        type: actionCreator(templateTypes.UPDATE_TRANSLATE_DESIGN_TEMPLATES, 'err'),
        key,
    };
}
// U P D A T E   T R A N S L A T E   D E S I G N   T E M P L A T E

// L O A D   D E S I G N   T E M P L A T E
export function loadDesignTemplate(id) {
    return {
        type: templateTypes.LOAD_DESIGN_TEMPLATES,
        id,
    };
}

export function loadDesignTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_DESIGN_TEMPLATES, 'res'),
        data,
    };
}

export function loadDesignTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_DESIGN_TEMPLATES, 'err'),
    };
}

export function setDesignTemplatePagination(key, pagination) {
    return {
        type: templateTypes.SET_DESIGN_TEMPLATES_PAGINATION,
        key,
        pagination,
    };
}
// L O A D   D E S I G N   T E M P L A T E

// L O A D   E D I T A B L E   D E S I G N   T E M P L A T E
export function loadEditableDesignTemplate(id) {
    return {
        type: templateTypes.LOAD_EDITABLE_DESIGN_TEMPLATES,
        id,
    };
}

export function loadEditableDesignTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_EDITABLE_DESIGN_TEMPLATES, 'res'),
        data,
    };
}

export function loadEditableDesignTemplateErr(error) {
    return {
        type: actionCreator(templateTypes.LOAD_EDITABLE_DESIGN_TEMPLATES, 'err'),
        error,
    };
}

export function setEmptyEditableDesignTemplate() {
    return {
        type: templateTypes.SET_EMPTY_EDITABLE_DESIGN_TEMPLATES,
    };
}
// L O A D   E D I T A B L E   D E S I G N   T E M P L A T E

// L O A D   R E S E L L E R S   F O R   D E S I G N   T E M P L A T E
export function loadResellersForDesignTemplate() {
    return {
        type: templateTypes.LOAD_RESELLERS_FOR_DESIGN_TEMPLATES,
    };
}

export function loadResellersForDesignTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_RESELLERS_FOR_DESIGN_TEMPLATES, 'res'),
        data,
    };
}

export function loadResellersForDesignTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_RESELLERS_FOR_DESIGN_TEMPLATES, 'err'),
    };
}
// L O A D   R E S E L L E R S   F O R   D E S I G N   T E M P L A T E

// L O A D   P R O D U C T   G R O U P S   F O R   D E S I G N   T E M P L A T E
export function loadProductsGroupForDesignTemplate() {
    return {
        type: templateTypes.LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES,
    };
}

export function loadProductsGroupForDesignTemplateRes(data) {
    return {
        type: actionCreator(templateTypes.LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES, 'res'),
        data,
    };
}

export function loadProductsGroupForDesignTemplateErr() {
    return {
        type: actionCreator(templateTypes.LOAD_PRODUCT_GROUPS_FOR_DESIGN_TEMPLATES, 'err'),
    };
}
// L O A D   P R O D U C T   G R O U P S   F O R   D E S I G N   T E M P L A T E

// E D I T   D E S I G N   T E M P L A T E
export function editDesignTemplate(data) {
    return {
        type: templateTypes.EDIT_DESIGN_TEMPLATE,
        data,
    };
}

export function editDesignTemplateRes(success) {
    return {
        type: actionCreator(templateTypes.EDIT_DESIGN_TEMPLATE, 'res'),
        success,
    };
}

export function editDesignTemplateErr(error) {
    return {
        type: actionCreator(templateTypes.EDIT_DESIGN_TEMPLATE, 'err'),
        error,
    };
}
// E D I T   D E S I G N   T E M P L A T E
